import { MdOutlinePlaylistAdd } from "react-icons/md";
export const supplierFeatureMenu = [
  {
    id: "1",
    name: "ویژگی سطح اول",
    path: `/dashboard/suppliers/ContentUnit/features/level-one`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
  {
    id: "2",
    name: "ویژگی سطح دوم",
    path: `/dashboard/suppliers/ContentUnit/features/level-two`,
    icon: <MdOutlinePlaylistAdd size={25} />,
    color: "#0062FF",
    type: "menu",
  },
];
